import { SET_IS_LOGIN } from '../types/types';

export const setSessionData = (sessionData) => ({
    type: SET_IS_LOGIN,
    payload: sessionData,
});
